export function setSliderHeight() {
    const $tabContentHeight = $('.tab-content').height();
    const $tabFirstPaneHeight = $('.tab-pane:first').height();

    $('.vertical').css('height', $tabFirstPaneHeight);
    $('.horizontal').css('height', $tabFirstPaneHeight > $tabContentHeight ? $tabFirstPaneHeight : $tabContentHeight);
}

export function isInternetExplorer() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('MSIE ');

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        return true;
    } else {
        return false;
    }
}



// WEBPACK FOOTER //
// ./js/common.js